// Utils.js

// convertAsciiControlChars, normalizeUrl, getBrandValue are defined in public/shared-utils.js
const convertAsciiControlChars = window.convertAsciiControlChars;
const normalizeUrl = window.normalizeUrl;
const getBrandValue = window.getBrandValue;

function getUrlParameter (key) {
  const paramsURL = new URL(window.location.href);
  let params = new URL(paramsURL).searchParams;
  let value = params.get(key);
  return value;
}

function checkUrlParameter (key, value) {
  let currentValue = getUrlParameter(key);
  if (currentValue === value) {
    return true;
  } else {
    return false;
  }
}

const getOriginUrl = () => {
  var href = window.location.href;
  var referrer = document.referrer;

  if(window.parent !== window) {
    console.debug(`getOriginUrl | Origin ${href} loaded inside iframe from ${referrer}.`)
    return referrer;
  } else {
    console.debug(`getOriginUrl | App loaded from origin: ${href}`)
    return href;
  }
}

const getOs = () => {
  const platform = (navigator.userAgentData?.platform || navigator.platform)?.toLowerCase();
  if(platform.startsWith("win")) return "windows";
  if(platform.startsWith("mac")) return "macos";
  if(platform.startsWith("linux")) return "linux";
  return "unknown";
}

function isPwa() {
  return ["fullscreen", "standalone", "minimal-ui"].some(
      (displayMode) => window.matchMedia('(display-mode: ' + displayMode + ')').matches
  );
}

const isLocalhost = Boolean (
  window.location.hostname === 'localhost' ||
  // [::1] is the IPv6 localhost address.
  window.location.hostname === '[::1]' ||
  // 127.0.0.0/8 are considered localhost for IPv4.
  window.location.hostname.match(/^127(?:\.(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)){3}$/)
);

// Determines the app environment out of the hostname and an optional ENV url
// parameter. On iOS the parameters of a universal link are not part of
// window.location, so they can be passed in explicitly.
function resolveEnv (searchParams) {
  const params = searchParams ?? new URL(window.location.href).searchParams;
  const envParameter = params.get('ENV');
  const subdomain = window.location.hostname.split('.').slice(0, -2).join('.');

  if (isLocalhost ||
      subdomain.includes('remote') ||
      subdomain.includes('dev') ||
      envParameter === 'dev')
  {
    return 'dev';
  } else if (subdomain.includes('stg') ||
             subdomain.includes('staging') ||
             envParameter === 'stg')
  {
    return 'stg';
  }
  return 'prd';
}

// https://css-tricks.com/snippets/javascript/lighten-darken-color/
function lightenDarkenColor(col, amt) {

  let usePound = false;

  if (col[0] === "#") {
    col = col.slice(1);
    usePound = true;
  }

  const num = parseInt(col,16);

  let r = (num >> 16) + amt;

  if (r > 255) r = 255;
  else if  (r < 0) r = 0;

  let b = ((num >> 8) & 0x00FF) + amt;

  if (b > 255) b = 255;
  else if  (b < 0) b = 0;

  let g = (num & 0x0000FF) + amt;

  if (g > 255) g = 255;
  else if (g < 0) g = 0;

  return (usePound?"#":"") + (g | (b << 8) | (r << 16)).toString(16);
}

export {
  checkUrlParameter,
  getBrandValue,
  getOriginUrl,
  getUrlParameter,
  getOs,
  isPwa,
  resolveEnv,
  isLocalhost,
  convertAsciiControlChars,
  normalizeUrl,
  lightenDarkenColor
};
